import React from 'react'
import Group from 'components/utils/Group'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'

function DreamArticleUSPSkeleton() {
  return (
    <Group
      gap={16}
      tabletGap={20}
      direction="horizontal-reverse"
      tabletDirection="horizontal"
      verticalAlign="start"
      tabletVerticalAlign="center"
      horizontalAlign="space-between"
      tabletHorizontalAlign="start"
    >
      <Group direction="vertical" gap={4} fullWidth>
        <TextLoadingBox
          lines={1}
          typography="body-medium"
          width="100%"
        />
        <TextLoadingBox
          lines={1}
          typography="body-medium"
          width="100%"
        />
        <TextLoadingBox
          lines={2}
          typography="body-large"
          width="100%"
        />
        <Group direction="horizontal" gap={32}>
          <TextLoadingBox
            lines={1}
            typography="body-medium"
            width="100%"
          />
        </Group>
      </Group>
    </Group>
  )
}

export default DreamArticleUSPSkeleton
